<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table
          hide-upsert
          title="Protocols"
          :config="config"
          @saved="newProtocol"
          @edit="editProtocol"
          @new_user_survey="open_in_new">

        <template slot='headerActions'>

            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                 <v-btn
                  v-on="on"
                  :loading="loadingExport['excel']"
                  v-if="$can('export', 'protocol')"
                  color="secondary"
                  @click="export_excel()">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Export Excel</span>
            </v-tooltip>


            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  :loading="loadingExport['csv']"
                  v-if="$can('export', 'protocol')"
                  color="secondary"
                  @click="export_csv()">
                  <v-icon>mdi-file-delimited</v-icon>
                </v-btn>

              </template>
              <span>Export CSV</span>
            </v-tooltip>


            <!-- issue 216 -->
            <!--
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                 <v-btn
                  v-on="on"
                  :loading="loadingExport['excel_details']"
                  v-if="$can('export', 'protocol')"
                  color="secondary"
                  @click="export_excel_details()">
                  <v-icon>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Export Excel Details</span>
            </v-tooltip>
            -->
            <!-- issue 216 -->

             <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  v-if="$can('upsert', 'protocol')"
                  color="secondary"
                  @click="newProtocol()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>

              </template>
              <span>New Protocol</span>
            </v-tooltip>

          
        </template>

        </core-table>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import {export_data} from '@/api/export.js'
// import {getList} from '@/api/base_entity.js'

export default {
  data () {
    return {
      config,
      protocol: {},
      openRequest: false,
      loadingExport: {'csv':false, 'excel':false, 'excel_details': false},
    }
  },
  async mounted() {
    // for (let i = 0; i < this.config.fields.length; i++) {
    //   if(this.config.fields[i].value=='sponsor_id') {
    //     const ret = await getList('sponsor')
    //     this.config.fields[i].list = ret.data
    //   }
    // }
  },
  methods: {
     newProtocol () {
        this.$router.push(`/protocol/new`)
    //   this.openRequest = false
    // },
    // editProtocol() {
    //   this.openRequest = false
    },
    editProtocol(protocol) {
      //console.log("EDIT")
      this.$router.push(`/protocol/${protocol.id}`)
    },
    open_in_new(item) {
      window.open(window.location.origin + '/#/new_user/' + item.uuid, '_blank')
    },
    export_csv() {
      this.loadingExport['csv'] = true
      export_data('protocol').then( () => {
        this.loadingExport['csv'] = false
      })
    },
    export_excel() {
      this.loadingExport['excel'] = true
      export_data('protocol', 'excel').then( () => {
        this.loadingExport['excel'] = false
      })
    },
    export_excel_details() {
      this.loadingExport['excel_details'] = true
      export_data('protocol_details', 'excel').then( () => {
        this.loadingExport['excel'] = false
      }).finally( () => {
        this.loadingExport['excel_details'] = false
      })
    }
  }
}
</script>
